/**
 * Notification Service
 * In-app notifications API
 */
import api from './api'

const notificationService = {
  /**
   * Lay danh sach notifications
   * @param {Object} params
   * @param {number} params.limit - So luong (default 20, max 50)
   * @param {number} params.offset - Offset (default 0)
   * @param {boolean} params.unread_only - Chi lay chua doc
   */
  async getNotifications(params = {}) {
    try {
      const response = await api.get('/notifications', { params })
      return response.data
    } catch (error) {
      console.error('[Notification] Get notifications error:', error)
      return {
        status: 'error',
        data: {
          notifications: [],
          total: 0,
          unread_count: 0
        }
      }
    }
  },

  /**
   * Lay so luong notification chua doc
   * Dung cho badge tren Header
   */
  async getUnreadCount() {
    try {
      const response = await api.get('/notifications/unread-count')
      return response.data?.data?.unread_count || 0
    } catch (error) {
      console.error('[Notification] Get unread count error:', error)
      return 0
    }
  },

  /**
   * Danh dau 1 notification da doc
   * @param {number} notificationId
   */
  async markAsRead(notificationId) {
    try {
      const response = await api.post(`/notifications/${notificationId}/read`)
      return response.data
    } catch (error) {
      console.error('[Notification] Mark as read error:', error)
      throw error
    }
  },

  /**
   * Danh dau tat ca da doc
   */
  async markAllAsRead() {
    try {
      const response = await api.post('/notifications/read-all')
      return response.data
    } catch (error) {
      console.error('[Notification] Mark all as read error:', error)
      throw error
    }
  },

  /**
   * Xoa notification
   * @param {number} notificationId
   */
  async deleteNotification(notificationId) {
    try {
      const response = await api.delete(`/notifications/${notificationId}`)
      return response.data
    } catch (error) {
      console.error('[Notification] Delete error:', error)
      throw error
    }
  },

  /**
   * [Admin] Lay so luong users cho phe duyet
   * Dung de hien thi badge thong bao cho admin
   */
  async getAdminPendingCount() {
    try {
      const response = await api.get('/admin/users/pending-count')
      return response.data?.data || { pending_count: 0, pending_users: [] }
    } catch (error) {
      // Ignore 403 for non-admin users
      if (error.response?.status !== 403) {
        console.error('[Notification] Get pending count error:', error)
      }
      return { pending_count: 0, pending_users: [] }
    }
  }
}

export default notificationService
